/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fullScreen': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" _fill="#8300BF" cx="12" cy="12" r="12"/><path pid="1" d="M19.751 13.25v5H13.45v-1.5l4.802.001V13.25h1.5zm-14.001 0v3.5h4.801v1.5H4.25v-5h1.5zm4.801-8v1.5H5.75v3.5h-1.5v-5h6.301zm9.2 0v5h-1.5l.001-3.501-4.802.001v-1.5h6.301z" stroke-linecap="square" _fill="#FFF"/></g>'
  }
})
